// src/services/authService.js

// 1. Import Supabase client instead of Firebase
// Ensure you have created this client in a separate file (e.g., supabaseClient.js)
import { supabase } from '../supabaseClient';

// --- 1. Sign Up ---
export const signup = async (name, email, password) => {
  try {
    // CHANGE: Used supabase.auth.signUp instead of createUserWithEmailAndPassword
    // CHANGE: Passed 'name' directly into 'options.data' (this replaces updateProfile)
    const { data, error } = await supabase.auth.signUp({
      email: email,
      password: password,
      options: {
        data: {
          full_name: name, // Supabase stores profile info in 'user_metadata'
        },
        emailRedirectTo:
          window.location.hostname === "localhost"
            ? "http://localhost:3000/auth/callback"
            : "https://useocul.com/auth/callback",
      },
    });

    if (error) throw error;
    return { success: true, user: data.user };

  } catch (error) {
    return { success: false, error: error.message };
  }
};

// --- 2. Login with Email/Password ---
export const login = async (email, password) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });

    if (error) throw error;

    return { success: true, user: data.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// --- 3. Login/Sign Up with Google ---
export const authWithGoogle = async () => {
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {

        redirectTo:
          window.location.hostname === "localhost"
            ? "http://localhost:3000/auth/callback"
            : "https://useocul.com/auth/callback",

        queryParams: {
          access_type: 'offline',
          prompt: 'consent',
        },
      },
    });

    if (error) throw error;
    return { success: true, user: data };

  } catch (error) {
    return { success: false, error: error.message };
  }
};
// --- 4. Logout ---
export const handleLogout = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) console.error("Error signing out: ", error);
};